import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { Button as i } from "../../forms/button/index.js";
import '../../../assets/update.css';const p = "_update_17tsl_1", a = {
  update: p,
  "update--info": "_update--info_17tsl_7",
  "update--info--subtitle": "_update--info--subtitle_17tsl_9",
  "update--info--title": "_update--info--title_17tsl_11",
  "update--info--paragraph": "_update--info--paragraph_17tsl_13",
  "update--info--actions": "_update--info--actions_17tsl_16",
  "update--info--actions--button__advisor": "_update--info--actions--button__advisor_17tsl_22",
  "update--figure": "_update--figure_17tsl_25"
};
function m({
  quoteButtonContent: s = "Cotizar ahora",
  onClickQuoteButton: o = () => {
  },
  advisorButtonContent: n = "Consultar a nuestros asesores",
  onClickAdvisorButton: d = () => {
  },
  content: u = "Nos encargamos de regularizar tu inmueble hasta obtener el Certificado de Título, con opciones de pago flexibles de hasta 36 cuotas mensuales sin intereses ni penalidades. Puedes pagar automáticamente con tarjeta y recibir asistencia durante todo el proceso de forma automatizada.",
  subtitle: l = "Todas las facilidades en un solo lugar",
  title: r = "Actualiza y regulariza tu propiedad con nosotros",
  figureContent: c = ""
}) {
  return /* @__PURE__ */ t("section", { className: `${a.update}`, children: [
    /* @__PURE__ */ t("article", { className: `${a["update--info"]}`, children: [
      /* @__PURE__ */ e("h5", { className: `${a["update--info--subtitle"]} b-mb-4 md:b-mb-2`, children: l }),
      /* @__PURE__ */ e("h2", { className: `${a["update--info--title"]} b-mb-6 md:b-mb-4`, children: r }),
      /* @__PURE__ */ e("p", { className: `${a["update--info--paragraph"]} b-mb-6`, children: u }),
      /* @__PURE__ */ t("div", { className: `${a["update--info--actions"]}`, children: [
        /* @__PURE__ */ e(i, { className: "md:b-max-w-52", onClick: o, children: s }),
        /* @__PURE__ */ e(
          i,
          {
            className: `${a["update--info--actions--button__advisor"]}`,
            onClick: d,
            styleType: "link",
            children: n
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e("figure", { className: `${a["update--figure"]}`, children: c })
  ] });
}
export {
  m as default
};
